import { useEffect, useState } from 'react';
import { IS_SCHEDULE } from './contants';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function Clock({ data }) {
  const [timeDifference, setTimeDifference] = useState('');
  const [orderDates, setOrderDates] = useState({ order: 0, schedule: 0 });

  useEffect(() => {
    const order = new Date(data.DataPedido);
    const schedule = new Date(data.DataAgendamento).getTime();

    const [hour, min, sec] = data?.Hora?.split(':');
    order.setHours(hour);
    order.setMinutes(min);
    order.setSeconds(sec);

    setOrderDates({ order: order.getTime(), schedule });
  }, [data]);

  useEffect(() => {
    const changeDiference = () => {
      const compareTime = IS_SCHEDULE[data?.TipoEntrega]
        ? orderDates.schedule
        : orderDates.order;

      const formatedDistance = formatDistanceToNow(compareTime, {
        addSuffix: false,
        locale: ptBR,
        includeSeconds: true,
      });

      setTimeDifference(formatedDistance);
    };

    const interval = setInterval(changeDiference, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [data, orderDates]);

  return (
    <h6 style={{ color: '#fff', fontSize: 12 }}>
      {IS_SCHEDULE[data?.TipoEntrega] ? 'Faltam ' : 'Há '}
      {timeDifference}
    </h6>
  );
}
